import { TransactionStatus } from 'dashboard/models/transaction-status';
import { TransactionType } from 'dashboard/models/transaction-type';
import {
  TransactionStatusesActions,
  TransactionStatusesActionType,
} from 'dashboard/redux/actions/transaction-statuses';

export interface TransactionStatusesState {
  transactionStatuses: TransactionStatus[];
  transactionType: TransactionType;
}

export const initialTransactionStatusesState: TransactionStatusesState = {
  transactionStatuses: [],
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  transactionType: undefined,
};

export default (
  state: TransactionStatusesState = initialTransactionStatusesState,
  action: TransactionStatusesActions,
) => {
  switch (action.type) {
    case TransactionStatusesActionType.AppendTransactionStatuses: {
      return {
        ...state,
        transactionStatuses: [...state.transactionStatuses, ...action.payload.transactionStatuses],
      };
    }
    case TransactionStatusesActionType.SetTransactionStatuses: {
      return {
        ...state,
        transactionStatuses: action.payload.transactionStatuses,
      };
    }
    case TransactionStatusesActionType.UpdateTransactionStatus: {
      return {
        ...state,
        transactionStatuses: state.transactionStatuses.map((transactionStatus) => {
          if (transactionStatus.id === action.payload.transactionStatus.id) {
            return action.payload.transactionStatus;
          } else {
            return transactionStatus;
          }
        }),
      };
    }
    default:
      return state;
  }
};
